import styled from "styled-components";
import React, { useState, useRef, useEffect } from "react";
import { section } from "../../containers/HomePage/data.js";
import { data } from "./data.js"
import { ExpedientWay } from "../expedientway/index.jsx";
import { BusinessInquiriesForm } from "../form/index.jsx";
import { Link } from "react-router-dom";
// import TechHome       from "../../images/homesectionimages/TechPhoto.webp";



const StaffingPagesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    position:relative;
    height:100%;
    margin-top: 90px;
    background: linear-gradient(
        360deg,
        rgba(157, 34, 34, 0.45) -84.02%,
        rgba(255, 255, 255, 0.45) 108.77%
    );

    
    
    @media screen and (max-width: 768px){
        display: flex;
        flex-direction: column;
        width: 100%;
        poistion:relative;
        height:100%;
    }
`;

export const StaffingTextContent = styled.div`
    display:flex;
    flex-direction: column;
    width: 100%;
    height: 65%;
    align-items: center;
    justify-content: center;

`;
export const StaffingRedText = styled.h2`
    color: #9D2222;
    font-family: Roboto;
    font-size: 32px;
    font-weight: 500;
    margin-top: 10%;
    margin-bottom: 5%;

    @media screen and (max-width: 768px){
        font-size: 20px; 
        font-weight: bold;   
    }

`;

export const StaffingText = styled.h3`
    color: #121212;
    font-family: Roboto;
    font-size: 30px;
    font-style: italic;
    font-weight: 500;
    margin-bottom: 5%;

    @media screen and (max-width: 768px){
        font-size: 20px;
        font-weight: bold;
    }
`
export const StaffingParagraph = styled.p`
    color: #121212;
    font-family: Sunflower;
    font-size: 20px;
    font-style: italic;
    font-weight: 300;

    @media screen and (max-width: 768px){
        font-size: 13px;
        padding-bottom: 8%;

    }
`;

const StaffingImageContentContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    padding: 20px;
    width: 80%;
    margin: 0 auto;
    grid-gap: 2%;

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        width: 100%;
        padding: 0px;
        display: flex;
        flex-direction: column;
        height: auto;
  }
`;
const ContainerColumn = styled.div`
    /* flex: 1; */
    margin: 10px;
    text-align: center;
    position: relative;
    height: auto;


    @media screen and (max-width: 768px) {
        flex: 100%; 
        margin: 0px;
        padding-bottom: 10px;
  }
`;

const ContainerColumnImage = styled.img`
    width: 100%;
    height: 48.875vh;
    transition: filter 0,3s ease;

    &:hover {
        filter: grayscale(50%)
    }

    @media screen and (max-width: 768px) {
        height: 40vh;
    }
`;

const ContainerColumnTitle = styled.h2`
    color: ${({ special }) => (special ? "white" : "black")};
    font-size: 24px;
    font-family: Sunflower;
    font-weight: 500;
    position: absolute; 
    top: 40%;
    left: 0;
    width: 60%; 
    text-align: left; 
    padding-left: 7%;

    @media screen and (max-width: 768px){
        font-size: 18px;
        top: 36%;
    }
`;

const ContainerColumnText = styled.p`
    color: ${({ special }) => (special ? "white" : "black")};
    font-family: Sunflower;
    font-size: 16px;
    font-weight: 400;
    position: absolute;
    left: 0;
    top: 60%;
    width: 70%;
    text-align: left;
    padding-left: 7%;

    @media screen and (max-width: 768px){
        font-size: 11px;
        top: 53%;
    }

`;

const NimbleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position:relative;
    height: 100%;
    background: white;

`

const NimbleBox = styled.p`
    display: inline-block;
    align-items: center;
    justify-content: center;
    background: black;
    color: white;
    width: 60%;
    height: 70px;
    font-family: Roboto;
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    font-variant: small-caps;
    margin-top: 10%;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;

    span {
        text-decoration: underline;
        display: inline-block;
    }

    @media screen and (max-width: 768px){
        display: inline-block;
        flex-direction: row;
        font-size: 18px;
        width: 83%;
        padding-left: 20px;
        padding-right: 20px;
        padding: 4%;
        span {
            display: inline-block;
        }
    }
`;

const NimbleText = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #595959;
    font-family: Roboto;
    font-size: 23px;
    font-style: italic;
    font-weight: 500;
    margin-top: 3%;
    margin-bottom: 8%;

    @media screen and (max-width: 768px) {
        font-size: 16px;
        width: 80%;
    }

`;

const HiringImgContainer = styled.div`
    display: grid;  
    width: 100%;
    margin-bottom: -68%;

    @media screen and (max-width: 768px){
        margin-bottom: -70%;
    }
`;


const ImgColumn = styled.div`
    position: relative;
    width: 100%;
    z-index: ${({right}) => (right ? 1 : 0)};
    bottom: ${({id}) => {
        if (id === 1) return "0%";
        if (id === 2) return "59%";
        if (id === 3) return "154%";
    }};
`;

const HiringImg = styled.img`
    width: 100%;

`;

const HireTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    right: ${({id}) => (id === 1 || id === 3 ? "10%" : "none")};
    left: ${({id}) => (id === 2 ? "5%" : "none")};
    top: ${({ id }) => {
        if (id === 1) return "16%";
        if (id === 2) return "43%";
        if (id === 3) return "70%";
        return "0";
    }};

    @media screen and (max-width: 768px){
        width: 40%;
        top: ${({ id }) => {
            if (id === 1) return "16%";
            if (id === 2) return "43%";
            if (id === 3) return "40%";
            return "0";
        }};
    }


`

const HireText = styled.h2`
    color: #9D2222;
    font-family: Sunflower;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 5px;

    @media screen and (max-width: 768px){
        font-size: 12px;
    }

`;

const HireP = styled.p`
    color: black;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 5px;

    @media screen and (max-width: 768px){
        font-size: 10px;
    }

`;

const HireH3 = styled.h3`
    color: black;
    font-family: Roboto;
    font-size: 26px;
    font-style: italic;
    font-weight: 500;
    margin-bottom: 5px;

    @media screen and (max-width: 768px){
        font-size: 10px;
        font-weight: bold;
    }
`;

export const ContactUsDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: white;
    padding: 10%;

`;

export const ContactUsText = styled.h3`
    font-family: Sunflower;
    padding-bottom: 3%;

    @media screen and (max-width: 768px){
        font-size: 14px;
        font-weight: 500;
        width: 348px;
    }
`;
export const ContactUsButton = styled.button`
    color: white;
    background: #9D2222;
    border-radius: 50px;
    border: 0.75px solid #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    width: 15%;
    font-size:18px;
    height: 40px;
    cursor: pointer;

    @media screen and (max-width: 768px){
        width: 92px;
        height: 22.917px;
        font-size: 10px;
    }
`;

const ExpWayWrapper = styled.div`
    
    @media screen and (max-width: 768px){
        background: linear-gradient(180deg, rgba(157, 34, 34, 0) 80%, white 90%);
    }
`;


export function StaffingHomepage () {
    const formRef = useRef(null);
    const [isFormVisible, setIsFormVisible] = useState(false);

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible)
    }

    useEffect(() => {
        const handleDocumentClick = (e) => {
          if (isFormVisible && formRef.current && !formRef.current.contains(e.target)) {
            toggleFormVisibility(); // Close the form if it's visible and the click is outside
          }
        };
    
        document.addEventListener('click', handleDocumentClick);
    
        return () => {
          document.removeEventListener('click', handleDocumentClick);
        };
    }, [isFormVisible]);
    
    
    return(
        <StaffingPagesContainer id="staffing-pages">
            <StaffingTextContent>
                <StaffingRedText>THE LABOR POOL IS <span style={{ fontWeight: "bold", fontSize: "42px"}}>HUGE.</span></StaffingRedText>
                <StaffingText>SWIM AGAINST THE TIDE</StaffingText>
                <StaffingParagraph>Tired of candidates that don't measure up? <br/>Our specialists identify the qualities other staffing agencies miss.</StaffingParagraph>
            </StaffingTextContent>
            <StaffingImageContentContainer id="image-content-container">
                {section.map((item => (
                    <ContainerColumn id ="cont"key={item.id}>
                        <Link to={`/${item.place}`} key={item.id}>
                            <ContainerColumnImage src={item.img} alt={item.altt}/>
                            <ContainerColumnTitle special={item.special} >{item.title}</ContainerColumnTitle>
                            <ContainerColumnText special={item.special} >{item.text}</ContainerColumnText>
                        </Link>
                    </ContainerColumn>
                )))}
            </StaffingImageContentContainer>
            <ExpWayWrapper>
                <ExpedientWay/>
            </ExpWayWrapper>
            <NimbleContainer>
                <NimbleBox>WE TAKE PRIDE IN OUR ABILITY TO BE <span>NIMBLE</span></NimbleBox>
                <NimbleText>No matter your situation, our hiring solutions meet you where you are.</NimbleText>
            </NimbleContainer>
            <HiringImgContainer id="hiring-img-container">
                {data.map((item => (
                    <ImgColumn key={item.id} right={item.right} id={item.id}
                    >
                        <HireTextWrapper id={item.id}>
                            <HireText>{item.title}</HireText>
                            <HireP>{item.question}</HireP>
                            <HireH3>{item.text}</HireH3>
                        </HireTextWrapper>
                        <HiringImg src={item.img} />
                    </ImgColumn>
                )))}
            </HiringImgContainer>
            <ContactUsDiv>
                <ContactUsText>Ready to revamp your workforce? Reach out!</ContactUsText>
                <ContactUsButton onClick={toggleFormVisibility}>Contact Us</ContactUsButton>
                {isFormVisible && (
                    <div style={{paddingTop: "5%"}} ref={formRef}>
                        <BusinessInquiriesForm />
                    </div>
                )}
            </ContactUsDiv>
        </StaffingPagesContainer>

    )
}